import { isEmptyObject } from "./isEmptyObject";

export function getValueFromPath(
  obj: Record<string, any> | null | undefined,
  pathAsString: string,
  defaultValue: any = undefined
) {
  if (!obj || isEmptyObject(obj)) {
    return defaultValue;
  }

  const stringToPath = pathAsString.split(/[?!(^.[\])]+/);
  const valueForPath = stringToPath.reduce(
    (acc, curr) =>
      acc && typeof acc[curr] !== "undefined" ? acc[curr] : undefined,
    obj
  );

  return typeof valueForPath === "undefined" ? defaultValue : valueForPath;
}
